import { render, staticRenderFns } from "./Loader_Compartido.vue?vue&type=template&id=e43e65d2&"
import script from "./Loader_Compartido.vue?vue&type=script&lang=js&"
export * from "./Loader_Compartido.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports